export default __webpack_public_path__ + "static/media/blackberry-radar.18ff9b30.png";